import { makePostApiCall } from "./makeApiCall";

export async function fetchUsersForDropdown(type, department) {
  return makePostApiCall("usersForDropdown", {
    type: Array.isArray(type) ? type : [type],
    department: Array.isArray(department) ? department : [department],
  });
}
